module.exports = __webpack_public_path__ + "static/quince-1d61261362195eca4ac31c2cfd3112ad.svg";